function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_smartphone"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m8.613 4.081c.112-.054.242-.081.387-.081h6c.551 0 1 .448 1 1v7c0 .553.448 1 1 1s1-.447 1-1v-7c0-1.654-1.346-3-3-3h-6c-.447 0-.869.094-1.253.278-.497.24-.707.837-.468 1.334.239.499.839.71 1.334.469z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3.707 3.707v11.586c0 1.654 1.346 3 3 3h6c1.525 0 2.774-1.148 2.962-2.624l2.331 2.331c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-5.707-1.293c0 .552-.449 1-1 1h-6c-.551 0-1-.448-1-1v-9.586l8 8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 18,
  r: 1
})));

var Svg081Nosmartphones = function Svg081Nosmartphones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg081Nosmartphones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/081-no smartphones.1961e9c0.svg";
export { ForwardRef as ReactComponent };